let nextId = 1
 const NotificationModule = {
  namespaced: true,
  state: {
    notifications: []
  },
  mutations: {
    PUSH(state, notification) {
      state.notifications.push({
        ...notification,
        id: nextId++
      })
    },
    DELETE(state, notificationToRemove) {
      // state.notifications = state.notifications.filter(
      //   notification => notification.id !== notificationToRemove.id
      // )
      state.notifications = []
    }
  },
  actions: {
    add({ commit }, notification) {
      commit('PUSH', notification)
      // iziToast.info({
      //   title: notification.message,
      //   position: 'bottomRight'
      // })
    },
    remove({ commit }, notificationToRemove) {
      commit('DELETE', notificationToRemove)
    }
  },
  getters: {
    getAll: state => {
      return state.permission
    }
  }
}

export default NotificationModule



// WEBPACK FOOTER //
// ./src/store/modules/notification.js